import axios from "axios";

const API = axios.create({
  baseURL: "https://flavoursnest-be.onrender.com/api", // change if needed
});

// ================= CATEGORY APIs =================

export const getAllCategories = () => {
  return API.get("/view-categories");
};

// ================= RECIPE =================
export const getAllRecipes = (category_id) => {
  if (category_id) {
    return API.get(`/view-recipes?category_id=${category_id}`);
  }
  return API.get(`/view-recipes`);
};
export const getRecipeById = (recipe_id) => {
  return API.get(
    `/view-recipesbyid?recipe_id=${recipe_id}`
  );
};
export const getHeroRecipe = () => {
  return API.get(
    `/view-herorecipe`
  );
};


export const getRecipeDetails = (recipeId) =>
  API.get(`/recipe-details/${recipeId}`);


// ================= INGREDIENTS =================

export const getIngredients = (detailsId) =>
  API.get(`/recipe-ingridients/${detailsId}`);

// ================= Contact Us =================

export const postContactus = (data) =>{
return API.post(`/contact`,data);}

export const addReview = (data) => {
  return API.post("/add-review", data);
};

export const getReviews = (recipe_id) => {
  return API.get(`/get-reviews?recipe_id=${recipe_id}`);
};
export const getRelatedRecipes = (recipeId) => {
  return API.get(`/recipes/related/${recipeId}`);
};

export const searchRecipesByIngredients = (ingredients) => {
  return API.post(`/by-ingredients`, {
    ingredients
  });
};
export const getAllIngredients = () => {
  return API.get("/ingredients");
};
export default API;